const CapesizeImage = require("../../assets/images/Capesize.png");
const KamsarmaxImage = require("../../assets/images/Capesize.png");
// const CapesizeImage = require('../../assets/images/Capesize.png');
// const CapesizeImage = require('../../assets/images/Capesize.png');
// const CapesizeImage = require('../../assets/images/Capesize.png');
// const CapesizeImage = require('../../assets/images/Capesize.png');
// const CapesizeImage = require('../../assets/images/Capesize.png');
// const CapesizeImage = require('../../assets/images/Capesize.png');

export const VESSEL_OPTIONS = [
  {
    name: "Supra/Ultramax",
    speedOptions: [11, 12, 13, 14],
  },
  {
    name: "Kamsarmax",
    speedOptions: [11, 12, 13, 14],
  },
  {
    name: "Capesize",
    speedOptions: [11, 12, 13, 14, 15],
  },
  {
    name: "Newcastlemax",
    speedOptions: [11, 12, 13, 14, 15],
  },
  {
    name: "VLOC",
    speedOptions: [11, 12, 13, 14, 15],
  },
  {
    name: "MR Tanker",
    speedOptions: [11, 12, 13, 14],
  },
  {
    name: "LR Tanker",
    speedOptions: [11, 12, 13, 14, 15],
  },
  {
    name: "VLCC",
    speedOptions: [11, 12, 13, 14, 15],
  },
];
